function getOrganizationsWithSelectedOnTop(organizations, selectedOrganizationId) {
    const organizationsCopy = [...organizations];

    organizationsCopy.sort((a, b) => {
        if (a.id === selectedOrganizationId) {
            return -1;
        }
        return 0;
    });

    return organizationsCopy;
}

export { getOrganizationsWithSelectedOnTop };
